<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <account-overview type="month" title="Statistics" />
      </v-col>
      <v-col cols="12" md="6">
        <reporting-period period="monthly" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <campaign-tracking :items="monthlyStatistics.campaignTracking" />
      </v-col>
      <v-col cols="12">
        <click-breakdown :items="monthlyStatistics.clickBreakdown" />
      </v-col>
      <v-col cols="12">
        <acquisition-details :items="monthlyStatistics.acquisitionDetails" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AccountOverview from '@/components/Affiliates/Statistics/AccountOverview'
import ReportingPeriod from '@/components/Affiliates/Statistics/ReportingPeriod'
import CampaignTracking from '@/components/Affiliates/Statistics/CampaignTracking'
import ClickBreakdown from '@/components/Affiliates/Statistics/ClickBreakdown'
import AcquisitionDetails from '@/components/Affiliates/Statistics/AcquisitionDetails'

export default {
  name: 'MonthlyReport',
  components: {
    AccountOverview,
    ReportingPeriod,
    CampaignTracking,
    ClickBreakdown,
    AcquisitionDetails
  },
  computed: mapGetters({
    monthlyStatistics: 'affiliates/monthlyStatistics'
  }),
  methods: {
    ...mapActions({
      getMonthlyStatistics: 'affiliates/getMonthlyStatistics',
      reportError: 'reportError'
    }),
  },
  async mounted () {
    try {
      await this.getMonthlyStatistics()
    } catch (e) {
      this.reportError(e)
    }
  }
}
</script>

<style scoped>

</style>
